import { render, staticRenderFns } from "./VideoRecognitionList.vue?vue&type=template&id=88f38354"
import script from "./VideoRecognitionList.vue?vue&type=script&lang=js"
export * from "./VideoRecognitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports